module.exports = __webpack_public_path__ + "static/img/atm.92773ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/atm.png
// module id = f321
// module chunks = 0